var jvLang = window.location.hostname.indexOf('fr') >= 0 ? 'fr' : 'en';

(function (algolia) {
  'use strict';

  if (window.location.hostname.indexOf('localhost') >= 0 || jvLang === 'fr') {

    // -----------> Algolia French Version 

    algolia.translations = {
      search: "Recherche en cours",
      noCollectionFound: "Aucune collection trouvée",
      allProducts: "Voir tous les produits",
      matching: "correspondant à",
      sortBy: "Trier par",
      relevance: "Pertinence",
      outOf: "hors de",
      resultsFound: "résultats trouvés",
      oneResultFound: "1 résultat trouvé",
      noResultFound: "Aucun résultat trouvé",
      addToCart: "Ajouter au panier",
      searchForProduct: "Rechercher des produits",
      selectedFilter: "Filtres sélectionnés",
      clearAll: "Tout effacer",
      noPageFound: "Aucune page trouvée",
      outOfStock: "En rupture de stoc",
    };

    algolia.translation_helpers = {
      no_result_for: function (text, render) {
        return 'Aucun résultat pour la requête ' + render(text) + '';
      },
      in: function (text, render) {
        return 'dans ' + render(text) + 's';
      },

      try_clear_or_change_input: function (text, render) {
        var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
        var html_tags = text.match(regex);
        return 'Essayer ' + render(html_tags[0]) + ' effacement des filtres ' + render(html_tags[1]) + ' ou ' + render(html_tags[2]) + ' changer votre entrée ' + render(html_tags[3]) + '';
      },
      outOf: function (text, render) {
        return '' + render(text) + ' hors de';
      },

      by: function (text, render) {
        return 'par ' + render(text) + '';
      }
    };

  } else {
    
    // -----------> Algolia English Version
    
    algolia.translations = {
      search: "Current search",
      noCollectionFound: "No collection found",
      allProducts: "See all products",
      matching: "matching",
      sortBy: "Sort by",
      relevance: "Relevance",
      outOf: "out of",
      resultsFound: "results found",
      oneResultFound: "1 result found",
      noResultFound: "No result found",
      addToCart: "Add to cart",
      searchForProduct: "Search for products",
      selectedFilter: "Selected filters",
      clearAll: "Clear all",
      noPageFound: "No page found",
      outOfStock: "Out of stock",
    };

    algolia.translation_helpers = {
      no_result_for: function (text, render) {
        return 'No result for query ' + render(text) + '';
      },
      in: function (text, render) {
        return 'in ' + render(text) + 's';
      },

      try_clear_or_change_input: function (text, render) {
        var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
        var html_tags = text.match(regex);
        return 'Try ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' or ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]) + '';
      },
      outOf: function (text, render) {
        return '' + render(text) + ' out of';
      },

      by: function (text, render) {
        return 'by ' + render(text) + '';
      }
    };
  }

  

}(algoliaShopify));
